import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { getOtherEvaluation, getSelfEvaluation } from "../../redux/actions/evaluationConfirm";
import { PRIORITY_TARGET_CHECK_RESET, checkPriorityTarget, saveTarget } from "../../redux/actions/planningSheet";
import { PRINTING_RESET, print } from "../../redux/actions/printing";
import Footer from "../common/Footer";
import Header from "../common/Header";
import "../css/SelfEvaluation.css";

export default function Evaluation() {
  const [selectedItems, setSelectedItems] = useState([]); // [{ image, itemId, currentGrading }]
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("");

  const user = useSelector(state => state.auth.user);
  const serialNumber = user ? user.student.serialNumber : "";
  const grade = user ? user.student.grade : "";
  const classNumber = user ? user.student.classNumber : "";
  const number = user ? user.student.number : "";
  const name = user ? user.student.name : "";
  const selfEvaluationList = useSelector(state => state.evaluationConfirm.selfEvaluationList);
  const otherEvaluationList = useSelector(state => state.evaluationConfirm.otherEvaluationList);
  const gradeRange = useSelector(state => state.evaluationConfirm.gradeRange);
  const confirmSaveCheck = useSelector(state => state.planningSheet.confirmSaveCheck);
  const downloadLink = useSelector(state => state.printing.downloadLink);
  const isOther = searchParams.get("isOther") ? true : false;
  const termId = searchParams.get("termId");
  const listId = searchParams.get("listId");

  const dispatch = useDispatch();
  useEffect(
    () => {
      if (isOther) {
        dispatch(
          getOtherEvaluation({
            termId,
            listId
          })
        );
      } else {
        dispatch(
          getSelfEvaluation({
            termId,
            listId
          })
        );
      }
    },
    [dispatch]
  );

  useEffect(
    () => {
      if (downloadLink) {
        window.open(`/neqst${downloadLink}`, "_blank");
        dispatch({ type: PRINTING_RESET });
      }
    },
    [downloadLink]
  );

  useEffect(
    () => {
      if (confirmSaveCheck) {
        sendSelfPriorityTarget();
      }
    },
    [confirmSaveCheck]
  );

  const sendSelfPriorityTarget = () => {
    if (selectedItems.length !== 0) {
      const rows = selectedItems.map(item => ({
        serialNumber: serialNumber,
        grade: grade,
        classNumber: classNumber,
        number: number,
        name: name,
        termId: termId,
        listId: listId,
        itemId: item.itemId,
        currentGrading: item.currentGrading,
        targetGrading: "",
        approachScene: "",
        howToApproach: ""
      }));

      dispatch(
        saveTarget({
          listId,
          termId,
          rows
        })
      );
      // データが送信されたメッセージを表示
      setMessage(`${selectedItems.length}個重点目標を登録できました`);

      // チェックメッセージをリセットする
      dispatch({ type: PRIORITY_TARGET_CHECK_RESET });
    } else {
      // データがない場合にエラーメッセージを表示
      setMessage("重点目標を選択してください");
    }
  };

  const handleSendButtonClick = () => {
    dispatch(checkPriorityTarget({ listId, termId }));
  };

  const handleImageRemove = itemId => {
    setSelectedItems(prevSelected => prevSelected.filter(item => item.itemId !== itemId));
  };

  const handleClearImages = () => {
    setSelectedItems([]);
  };

  const handleImageClick = (image, itemId, currentGrading) => {
    if (selectedItems.length < 3) {
      // Only check itemId to avoid duplicates (itemId is unique, image can repeat)
      if (!selectedItems.some(item => item.itemId === itemId)) {
        setSelectedItems(prevSelected => [...prevSelected, { image, itemId, currentGrading }]);
        
        const clickedCard = document.querySelector(`[src="${image}"]`);
        clickedCard.classList.add("clicked");

        // 0.5秒後にclickedクラスを削除して元のサイズに戻す
        setTimeout(() => {
          clickedCard.classList.remove("clicked");
        }, 200);
      }
    }
  };

  const handleSelfEvaluationButton = () => {
    window.location.href = `/Evaluation?listId=${listId}&termId=${termId}`;
  };

  const handleOtherEvaluationButton = () => {
    window.location.href = `/Evaluation?isOther=${true}&listId=${listId}&termId=${termId}`;
  };

  const handleEvaluationComparisonButton = () => {
    window.location.href = `/EvaluationComparison?listId=${listId}&termId=${termId}`;
  };

  const handlePlanningSheetButton = () => {
    window.location.href = `/PlaningSheet?listId=${listId}&termId=${termId}`;
  };

  const handlePrintButton = () => {
    const request = {
      printTarget: isOther ? 2 : 1,
      termId,
      listId,
      students: [
        {
          serialNumber: user.student.serialNumber,
          grade: user.student.grade
        }
      ]
    };
    dispatch(print(request));
  };

  const handleBackButton = () => {
    window.location.href = `/EvaluationConfirm?listId=${listId}&termId=${termId}`;
  };

  const grades = gradeRange
    ? Array.from({ length: gradeRange.end - gradeRange.start + 1 }, (_, i) => {
        const gradeNum = gradeRange.start + i;
        return ["S", "A", "B", "C", "D", "E"][gradeNum - 1];
      })
    : ["S", "A", "B", "C", "D", "E"]; 

  return (
    <Box>
      <Header />
      <Box sx={{ m: 1, alignItems: "center", justifyContent: "center" }}>
        <Typography component="h3" variant="h7">
          {!isOther ? "自己評価（あなた自身が考えるあなた）" : "他者評価（他の人から見たあなた）"}
        </Typography>
      </Box>
      <Container>
        <Grid container spacing={2}>
          <FormControl fullWidth sx={{ ml: 9, mt: 1 }}>
            <Typography component="h5" variant="h6" align="left">
              {user ? `${user.student.grade}年${user.student.classNumber}組　${user.student.name}` : null}
            </Typography>
          </FormControl>
          <Grid item xs={9}>
            {grades.map((grade, index) => (
              <div className="container" key={index}>
                <div className="div-1">{grade}</div>
                <div className="div-2">
                  {isOther
                    ? otherEvaluationList[`level${grade}List`]?.map(data => (
                        <div
                          className="cards"
                          key={data.itemId}
                          onClick={() =>
                            handleImageClick(`/neqst/images/${listId}/${data.fileName}`, data.itemId, data.grading)
                          }
                        >
                          <img src={`/neqst/images/${listId}/${data.fileName}`} width="100%" height={150} />
                        </div>
                      ))
                    : selfEvaluationList[`level${grade}List`]?.map(data => (
                        <div
                          className="cards"
                          key={data.itemId}
                          onClick={() =>
                            handleImageClick(`/neqst/images/${listId}/${data.fileName}`, data.itemId, data.grading)
                          }
                        >
                          <img src={`/neqst/images/${listId}/${data.fileName}`} width="100%" height={150} />
                        </div>
                      ))}
                </div>
              </div>
            ))}
          </Grid>
        </Grid>

        <Box
          maxWidth="md"
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "left",
            maxWidth: "78%"
          }}
        >
          {isOther
            ? <Button
                variant="contained"
                size="medium"
                onClick={handleSelfEvaluationButton}
                sx={{ bgcolor: "#82b1ff", mt: 2, fontSize: "15px", marginRight: 5, width: "80%" }}
              >
                自己評価（あなた自身が考えるあなた）
              </Button>
            : <Button
                variant="contained"
                size="medium"
                onClick={handleOtherEvaluationButton}
                sx={{ bgcolor: "#82b1ff", mt: 2, fontSize: "15px", marginRight: 5, width: "80%" }}
              >
                他者評価を見る（ほかの人から見たあなた）
              </Button>}
          <Button
            variant="contained"
            size="medium"
            onClick={handleEvaluationComparisonButton}
            sx={{ bgcolor: "#82b1ff", mt: 2, fontSize: "15px", marginRight: 5, width: "80%" }}
          >
            自己評価と他者評価の違いをチェック
          </Button>
          <Button
            variant="contained"
            size="medium"
            onClick={handlePlanningSheetButton}
            sx={{ bgcolor: "#82b1ff", mt: 2, fontSize: "15px", padding: "20px 0px", marginRight: 5, width: "80%" }}
          >
            現在の重点目標を見る
          </Button>
        </Box>

        <FormControl fullWidth sx={{ mt: 3 }}>
          <Typography component="h5" variant="h6" align="left">
            ３つの重点目標を選ぼう！
            <div className="div-plan-8">{message}</div>
          </Typography>
        </FormControl>
        <Grid container spacing={2}>
          <Box
            maxWidth="md"
            sx={{
              display: "flex",
              flexDirection: "row",
              maxWidth: "79%"
            }}
          >
            <Grid item xs={10} lg={8} marginTop={4} marginLeft={2}>
              <div class="div-3" style={{ display: "flex", flexDirection: "row", paddingTop: 16 }}>
                {/* selectedItemsが配列の場合のみmapメソッドを使用 */}
                {Array.isArray(selectedItems) &&
                  selectedItems.map((item, index) => (
                    <React.Fragment key={item.itemId}>
                      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <div className="cards" onClick={() => handleImageRemove(item.itemId)}>
                          <img src={item.image} width="100%" height="150px" />
                        </div>
                        <Typography variant="h7" align="center" paddingTop={2}>
                          {index === 0 && "1枚目"}
                          {index === 1 && "2枚目"}
                          {index === 2 && "3枚目"}
                        </Typography>
                      </div>
                    </React.Fragment>
                  ))}
              </div>
            </Grid>
            <Grid item xs={2} ml="100px">
              <FormControl sx={{ mt: 5 }}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleClearImages}
                  sx={{ bgcolor: "#82b1ff", padding: "15px 20px" }}
                >
                  現在のカードをクリア
                </Button>
              </FormControl>
              <FormControl sx={{ mt: 5 }}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleSendButtonClick}
                  sx={{ bgcolor: "#82b1ff", padding: "15px 50px" }}
                >
                  これに<br />決定！
                </Button>
              </FormControl>
            </Grid>
          </Box>
        </Grid>
        <Box maxWidth="md" sx={{ m: 1, display: "flex", mt: 5, maxWidth: "75%", alignItems: "left" }}>
          <Button
            variant="contained"
            size="medium"
            onClick={handlePrintButton}
            sx={{ bgcolor: "#82b1ff", marginRight: "auto" }}
          >
            印刷
          </Button>
          <Button
            variant="contained"
            size="medium"
            onClick={handleBackButton}
            sx={{ bgcolor: "#82b1ff", marginLeft: "auto", marginRight: "5px" }}
          >
            戻る
          </Button>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
}